import { routerStyxie } from '@/router/styxieBridge'
import { useMlapProjectStore } from '@/stores/mlapProject'
import { useMlapProjectPagesStore } from '@/stores/mlapProjectPages'

// Only editors get the page meta (mapKey). Later entries fetch the /mlap/ajax twins (router/routes/mlap.js).
Styxie.Initializers.MlapProjects = routerStyxie({
  actions: ['show', 'details', 'present'],
  hydrate: (props, pinia) => {
    useMlapProjectStore(pinia).hydrate(props.project)
    const pages = useMlapProjectPagesStore(pinia)
    if ('mapKey' in props) pages.hydrateMeta(props)
    if ('hiddenCardKeys' in props) {
      pages.hydratePage('dashboard', { hiddenCardKeys: props.hiddenCardKeys, trendsMetricColors: props.trendsMetricColors })
    }
  }
})
